/**
 * MiniMonth — mini-calendario compatto per la Vista Trimestre. Niente MIT
 * inline; solo heatmap + numero giorno + pallino per scadenze KR.
 */
import { useMemo } from 'react';
import { GIORNI_SHORT, MONTH_LABELS_IT, heatmapBg } from '../../lib/calendarConstants';

export default function MiniMonth({ year, month, data, todayIso, onPickDay }) {
  // Appiattisci le 6 settimane × 7 giorni una volta sola per render.
  const allDays = useMemo(
    () => (data?.weeks || []).flatMap((w) => w.giorni),
    [data],
  );
  return (
    <div className="border border-line" data-testid={`cal-mini-${year}-${month}`}>
      <div className="px-3 py-2 border-b border-line flex items-center justify-between">
        <span className="font-display text-sm tracking-tight">{MONTH_LABELS_IT[month - 1]}</span>
        <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-mute">{year}</span>
      </div>
      <div className="grid grid-cols-7 text-center">
        {GIORNI_SHORT.map((g, i) => (
          <div key={`mh-${i}`} className="py-1 font-mono text-[9px] uppercase tracking-[0.15em] text-mute border-b border-linesoft">
            {g}
          </div>
        ))}
        {allDays.map((g) => {
          const isToday = g.data === todayIso;
          const pct = g.mit_totale > 0 ? g.mit_fatte / g.mit_totale : 0;
          const bg = heatmapBg(g.stato, pct);
          return (
            <button
              key={g.data}
              onClick={() => onPickDay(g.data)}
              className="aspect-square relative flex items-center justify-center font-mono text-xs tabular-nums hover:bg-linesoft transition-colors"
              style={{
                backgroundColor: bg,
                opacity: g.in_mese ? 1 : 0.3,
                color: isToday ? 'var(--qp-canvas)' : undefined,
              }}
              data-testid={`cal-mini-day-${g.data}`}
              title={`${g.data} · ${g.mit_fatte}/${g.mit_totale} MIT${g.scadenze?.length ? ' · ' + g.scadenze.length + ' scadenze' : ''}`}
            >
              {isToday && <span className="absolute inset-1 bg-ink" />}
              <span className="relative z-10">{g.giorno}</span>
              {(g.scadenze || []).length > 0 && (
                <span className="absolute bottom-0.5 right-0.5 w-1 h-1 rounded-full bg-accent" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
